import { useCallback, useMemo, useState } from 'react';

import { Icon } from '../Icon/Icon';
import './StarRating.css';

interface IProps {
  rating: number | null;
  stars?: number;
  setRating: React.Dispatch<React.SetStateAction<number | null>>;
}

function StarRating({ rating, setRating, stars = 5 }: IProps) {
  const [hover, setHover] = useState<number | null>(null);
  const arr = useMemo(() => Array.from({ length: stars }, (_, index) => index), [stars]);

  const handleClick = useCallback(
    (idx: number) => {
      setRating(idx + 1);
    },
    [setRating],
  );

  const handleHover = useCallback((idx: number) => {
    setHover(idx + 1);
  }, []);

  return (
    <div className="star-rating" onMouseLeave={() => setHover(null)}>
      {arr.map((btn, i) => (
        <button
          className={`star-rating__star${
            hover ? (hover >= i + 1 ? ' active' : '') : rating && rating >= i + 1 ? ' active' : ''
          }`}
          type="button"
          onClick={() => handleClick(i)}
          onMouseEnter={() => handleHover(i)}
          key={btn}
        >
          <Icon.Star />
          <span className="sr-only">
            select {i + 1} {i === 0 ? 'star' : 'stars'}
          </span>
        </button>
      ))}
    </div>
  );
}

export default StarRating;
